/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 *
 * @export
 * @interface ShopOrderItem
 */
export interface ShopOrderItem {
  /**
   *
   * @type {number}
   * @memberof ShopOrderItem
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof ShopOrderItem
   */
  orderId?: number;
  /**
   *
   * @type {number}
   * @memberof ShopOrderItem
   */
  productId?: number;
  /**
   *
   * @type {number}
   * @memberof ShopOrderItem
   */
  quantity?: number;
  /**
   *
   * @type {number}
   * @memberof ShopOrderItem
   */
  price?: number;
  /**
   *
   * @type {string}
   * @memberof ShopOrderItem
   */
  productName?: string;
}

/**
 * Check if a given object implements the ShopOrderItem interface.
 */
export function instanceOfShopOrderItem(
  value: object
): value is ShopOrderItem {
  return true;
}

export function ShopOrderItemFromJSON(json: any): ShopOrderItem {
  return ShopOrderItemFromJSONTyped(json, false);
}

export function ShopOrderItemFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ShopOrderItem {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'] == null ? undefined : json['id'],
    orderId: json['orderId'] == null ? undefined : json['orderId'],
    productId: json['productId'] == null ? undefined : json['productId'],
    quantity: json['quantity'] == null ? undefined : json['quantity'],
    price: json['price'] == null ? undefined : json['price'],
    productName: json['productName'] == null ? undefined : json['productName'],
  };
}

export function ShopOrderItemToJSON(json: any): ShopOrderItem {
  return ShopOrderItemToJSONTyped(json, false);
}

export function ShopOrderItemToJSONTyped(
  value?: ShopOrderItem | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value['id'],
    orderId: value['orderId'],
    productId: value['productId'],
    quantity: value['quantity'],
    price: value['price'],
    productName: value['productName'],
  };
}
